var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "text-center pa-8",
      attrs: { "data-testid": "empty_state" },
    },
    [
      _c("v-icon", { attrs: { size: "80", color: "grey lighten-1" } }, [
        _vm._v("mdi-chart-timeline-variant"),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "mt-4 mb-2" }, [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c("p", { staticClass: "text--secondary mb-6" }, [
        _vm._v(_vm._s(_vm.$mpt(_vm.$t("description_timeline")))),
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: {
            color: "primary",
            large: "",
            "data-testid": "empty_state_create_button",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("create")
            },
          },
        },
        [
          _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
          _vm._v("\n    " + _vm._s(_vm.$t("create_button")) + "\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }